import DataErrorImg from './data-error.webp';

export { DataErrorImg };
